module.exports = __webpack_public_path__ + "static/media/slider5.40fb2373.jpg";